<template>
  <div :style="_style">
    <TextBoxComponent
      ref="_input"
      float-label-type="Always"
      :placeholder="placeholder"
      :value="modelValue"
      :autocomplete="autocompleteValue"
      :max-length="maxLength"
      :min-length="minLength"
      icon-css="e-search-icon"
      :name="name"
      :type="type"
      :multiline="multiline"
      @input="onInput"
    />
    <!--
    @input="$emit('update:modelValue', $event.value)"
-->
  </div>
</template>

<script setup lang="ts">
import {TextBoxComponent} from "@syncfusion/ej2-vue-inputs";
import {computed} from "vue";
import {ref} from "vue";
import getGuid from "@/shared/utils/getGuid";

interface Props {
  autocomplete?: string,
  placeholder?: string,
  modelValue?: string,
  maxLength?: number | string,
  minLength?: number | string,
  name?: string
  intervalModified?: () => void
  intervalLength?: number
  interval?: number
  type?: string
  width?: string
  multiline?: boolean

//  dataMsgContainerId:string|undefined
}

const props = withDefaults(defineProps<Props>(),
  {
    autocomplete: "on",
    placeholder: undefined,
    modelValue: undefined,
    maxLength: undefined,
    minLength: undefined,
    name: undefined,
    intervalModified: undefined,
    intervalLength: 3,
    interval: 1000,
    type: undefined,
    width: "160px",
    multiline: false
  }
)
const emits = defineEmits(['update:modelValue']);
/*
const emit = defineEmits(['update:modelValue'])
*/
const _input = ref<InstanceType<typeof TextBoxComponent> | null>(null)
const _interval = ref<number | undefined>(undefined)
const _key = ref("")


const autocompleteValue = computed(() => {
  return props.autocomplete === "false" || props.autocomplete === "off" ? "off" : "on"
})

const focus = () => {
  _input.value?.focusIn();
}

defineExpose({
  focus
})

/*
watch(props.modelValue,()=>{
  console.log("watch");
})
*/

const _style = computed<string>(() => props.width ? "width: " + props.width : "")

function onInput(args: any) {
  emits("update:modelValue", args.value)
  if (props.intervalModified) {
    if (_interval.value) {
      clearInterval(_interval.value)
    }
    _key.value = getGuid();
    if (args.value.length > 0 && args.value.length < props.intervalLength)
      return
    _interval.value = setInterval(async (key: string) => {
      if (_interval.value) {
        clearInterval(_interval.value)
      }
      if (key !== _key.value)
        return;
      if (props.intervalModified)
        props.intervalModified();
    }, props.interval, _key.value)
  }
}

</script>

<style scoped>

</style>
